export const gwpcf4 = 6630
export const gwpc2f6 = 11100

export const slopeMethodConstants = {
  horizontal_stud_soderberg: {
    cf4EmissionFactor: 0.165,
    c2f6EmissionFactor: 0.077
  },
  vertical_stud_soderberg: {
    cf4EmissionFactor: 0.058,
    c2f6EmissionFactor: 0.086
  },
  // modern_pointfed_pre_bake_without_fully_automated_anode_effect: {
  //   cf4EmissionFactor: 1.16,
  //   c2f6EmissionFactor: 0.121
  // },
  modern_point_feed_pre_bake: {
    cf4EmissionFactor: 0.104,
    c2f6EmissionFactor: 0.057
  },
  legacy_point_feed_pre_bake: {
    cf4EmissionFactor: 0.122,
    c2f6EmissionFactor: 0.097
  },
  centre_worked_pre_bake: {
    cf4EmissionFactor: 0.1416,
    c2f6EmissionFactor: 0.121
  },
  side_worked_pre_bake: {
    cf4EmissionFactor: 0.233,
    c2f6EmissionFactor: 0.28
  }
}

export const overvoltageMethodConstants = {
  centre_worked_pre_bake: {
    cf4EmissionFactor: 1.16,
    c2f6EmissionFactor: 0.121
  },
  side_worked_pre_bake: {
    cf4EmissionFactor: 3.65,
    c2f6EmissionFactor: 0.252
  }
}
